import React from 'react';
import styles from './Button.module.scss';

export type ButtonVariant = 'primary' | 'secondary' | 'green' | 'greenOutline' | 'dark' | 'ghost' | 'danger';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: ButtonVariant;
  size?: 'default' | 'sm';
  children: React.ReactNode;
}

export default function Button({ variant, size = 'default', className, children, ...props }: ButtonProps) {
  const classes = [styles.btn, styles[variant], size === 'sm' ? styles.sm : '', className].filter(Boolean).join(' ');

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}
